module.exports = __webpack_public_path__ + "fonts/AkkuratLL-BlackItalic.c79435df.otf";